
class HighlightAnchorNav {
    init() {
        let itemMap = {};
        let sections = document.querySelectorAll('[data-anchor]');

        sections.forEach((section, index) => {
            const link = document.querySelector(`[href="#${section.id}"]`);

            itemMap[index] = {
                section: section,
                link: link,
                top: Number(section.offsetTop - 400),
                bottom: Number(sections[index + 1]?.offsetTop ? sections[index + 1].offsetTop - 400 : document.documentElement.offsetHeight)
            };
        });

        let onScroll = () => {
            Object.keys(itemMap).forEach((section, index) => {

                if (window.scrollY > itemMap[index].top && window.scrollY < itemMap[index].bottom) {
                    itemMap[index].link.style.background = '#6565EA';
                    itemMap[index].link.style.color = 'white';
                } else {
                    itemMap[index].link.style.background = '';
                    itemMap[index].link.style.color = '';
                }
            });
        };
        
        // Initialize scroll event
        window.addEventListener('scroll', onScroll);
        onScroll();
    }
}

export default HighlightAnchorNav;